import { API, graphqlOperation } from "aws-amplify"
import * as Sentry from "@sentry/browser"
import { toast } from "react-toastify"

import {
  createPreferenceMercadoPago,
  getPaymentMercadoPago,
} from "../graphql/mutations"

import { trackEvent } from "../helpers/tracker"

const createPreference = async (
  user: User,
  amount: number,
  country: string,
  currency: string
): Promise<string | null> => {
  trackEvent("mercadopago:create-preference")

  try {
    const response = await API.graphql(
      graphqlOperation(createPreferenceMercadoPago, {
        id: user.id,
        amount,
        salesforceId: user.salesforceId,
        country,
        currency,
      })
    )

    // @ts-ignore
    const preference = response.data.createPreferenceMercadoPago
    console.log("🚀 ~ response:", response)
    console.log("preference", preference)
    return preference.preference_id
  } catch (error) {
    trackEvent("mercadopago:create-preference:error:generic")
    Sentry.setExtra("error", JSON.stringify(error))
    Sentry.captureException(error)
    toast.error(
      "Ocurrio un error inesperado, por favor vuelve a intentarlo mas tarde"
    )
  }

  return null
}

type PaymentType = {
  amount: number
  payment_date: string
  payment_id: string
  currency: string
  country: string
}

const getPayment = async (
  paymentId: string,
  user: User
): Promise<PaymentType | null> => {
  trackEvent("mercadopago:get-payment")

  try {
    const response = await API.graphql(
      graphqlOperation(getPaymentMercadoPago, {
        id: user.id,
        paymentId,
        salesforceId: user.salesforceId,
      })
    )

    // @ts-ignore
    const payment = response.data.getPaymentMercadoPago
    console.log("🚀 ~ response:", response)
    console.log("payment", payment)
    return payment
  } catch (error) {
    trackEvent("mercadopago:get-payment:error:generic")
    Sentry.setExtra("error", JSON.stringify(error))
    Sentry.captureException(error)
    toast.error(
      "Ocurrio un error inesperado, por favor vuelve a intentarlo mas tarde"
    )
  }
  return null
}

const exportParams = {
  createPreference,
  getPayment,
}

export default exportParams
